<nts-base-checkbox-text-box 
    #baseCheckboxTextBox 
    [(checkStatus)]="propertyViewModel.typedValue"
    [label]="propertyViewModel.metadataDescription"
    [isDisabled]="!(propertyViewModel.isEnabled$ | async)">
</nts-base-checkbox-text-box>